<template>
  <v-container>
    <v-row justify="center" align="center" class="text-left">
      <v-col cols="8">
        <p>Les soldats qui m'ont fait prisonnier ont enfermé quelques indices dans un coffre.</p>
        <p>Trouvez le code du cadenas pour accéder au contenu du coffre.</p>
        <p>Localisation: Chambrée de soldats</p>
      </v-col>
      <v-col cols="4">
        <v-img
          src="/img/vauban portrait.png"
          class="my-3"
        />
      </v-col>
    </v-row>
    <v-btn style="margin-bottom:80px" color="#FF9F51" dark @click="$emit('set-result',0)">retour menu</v-btn>
  </v-container>
</template>

<script>
  export default {
    name: 'Enigme2',
    data: () => ({
    }),
  }
</script>